import { render, staticRenderFns } from "./RoadUserTable.vue?vue&type=template&id=59257dae&"
import script from "./RoadUserTable.vue?vue&type=script&lang=js&"
export * from "./RoadUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports